/// Hashes a string to an integer
export function hashStringToU32(string: string): number {
	let hash = 0;
	if (string.length === 0) {
		return hash;
	}

	for (let i = 0; i < string.length; i++) {
		const char = string.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash |= hash; // Convert to 32bit integer
	}

	return hash;
}
